import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { sfx } from "@/lib/sound";

const API = process.env.REACT_APP_BACKEND_URL;
const CONSENT_KEY = "idevra_cookie_consent";
const VISITOR_KEY = "idevra_visitor_id";

const track = () => {
  let vid = localStorage.getItem(VISITOR_KEY);
  if (!vid) {
    vid = window.crypto?.randomUUID ? window.crypto.randomUUID() : `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(VISITOR_KEY, vid);
  }
  fetch(`${API}/api/visitors/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      visitor_id: vid,
      path: window.location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
    }),
  }).catch(() => {});
};

export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(CONSENT_KEY);
    if (choice === "accepted") track();
    else if (!choice) setOpen(true);
  }, []);

  const decide = (accepted) => {
    sfx.clank();
    localStorage.setItem(CONSENT_KEY, accepted ? "accepted" : "declined");
    setOpen(false);
    if (accepted) track();
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="cookie-consent-banner"
          className="fixed bottom-4 left-1/2 z-[60] w-[calc(100%-2rem)] max-w-xl"
          initial={{ opacity: 0, y: 40, x: "-50%" }}
          animate={{ opacity: 1, y: 0, x: "-50%" }}
          exit={{ opacity: 0, y: 30, x: "-50%" }}
          transition={{ type: "spring", stiffness: 260, damping: 26, delay: 1.2 }}
        >
          <div className="iv-glass flex flex-col gap-3 rounded-2xl p-4 shadow-xl sm:flex-row sm:items-center sm:gap-4 sm:p-5">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#0284C7]/10">
              <Cookie size={16} color="#0284C7" />
            </span>
            <p className="f-mono flex-1 text-[9px] leading-relaxed tracking-[0.12em] text-[#475569]">
              THIS CONSOLE USES COOKIES &amp; LOCAL STORAGE TO SAVE YOUR TROPHIES AND SOUND MIX, AND TO
              COUNT VISITORS. ACCEPT TO HELP US KEEP A RECORD OF EVERY OPERATOR WHO DOCKS IN.
            </p>
            <div className="flex shrink-0 items-center gap-2">
              <button
                type="button"
                data-testid="cookie-decline-btn"
                onClick={() => decide(false)}
                className="f-mono rounded-full border border-[#CBD5E1] px-4 py-2.5 text-[9px] tracking-[0.25em] text-[#64748B] transition-colors hover:border-[#94A3B8]"
              >
                DECLINE
              </button>
              <button
                type="button"
                data-testid="cookie-accept-btn"
                onClick={() => decide(true)}
                className="f-syncopate rounded-full bg-[#0284C7] px-5 py-2.5 text-[9px] tracking-[0.25em] text-white transition-colors hover:bg-[#0369A1]"
              >
                ACCEPT
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
